import {combineReducers} from "redux";
import UIReducer from './UI';
import applicationDataReducer from './applicationData';

export default combineReducers({
    UI: UIReducer,
    applicationData: applicationDataReducer,
});
